import { createAsyncAction } from 'store/actionConfigs';
import type { GalleryStaffGroup } from 'types/models';
import { PREFIX_ACTIONS } from './constants';

const getPendingGallery = createAsyncAction<void, GalleryStaffGroup[]>(PREFIX_ACTIONS + 'getPendingGallery');
const getApprovedGallery = createAsyncAction<void, GalleryStaffGroup[]>(PREFIX_ACTIONS + 'getApprovedGallery');
const staff = {
  getPendingGallery: createAsyncAction<void, GalleryStaffGroup[]>(PREFIX_ACTIONS + 'staff' + 'getPendingGallery'),
  getApprovedGallery: createAsyncAction<void, GalleryStaffGroup[]>(PREFIX_ACTIONS + 'staff' + 'getApprovedGallery'),
}

const galleryActions = {
  getPendingGallery,
  getApprovedGallery,
  staff,
};

export default galleryActions;
